export function downloadExportFile(): void {
  const path = window.location.pathname;

  const fileName = path.split('/')[path.split('/').length - 1];
  window.location.href = `${import.meta.env.VITE_API_VERSION}/download/${fileName}`
}
